import { render, staticRenderFns } from "./MyLists.vue?vue&type=template&id=4dd6cd4d&scoped=true"
import script from "./MyLists.vue?vue&type=script&lang=js"
export * from "./MyLists.vue?vue&type=script&lang=js"
import style0 from "./MyLists.vue?vue&type=style&index=0&id=4dd6cd4d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6cd4d",
  null
  
)

export default component.exports